import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import ja from "vuetify/src/locale/ja";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.blue.darken4, // #0D47A1
        background: "#F0F8FF", // #E3F2FD
        accent: colors.orange.accent3,
        white: "#FFFFFF", // #FFFFFF
      },
    },
  },
  lang: {
    locales: { ja },
    current: "ja",
  },
});
